export enum SchufaReportState {
  ACCEPTED = 'ACCEPTED',
  IN_PROGRESS = 'IN_PROGRESS',
  PROBLEM = 'PROBLEM',
  RESULT = 'RESULT',
  ERROR = 'ERROR',
  FATAL_ERROR = 'FATAL_ERROR'
}
